/**
 * The one screen's shell: import → disclose → reconstruct → ledger. A state
 * machine, not a router — the URL never changes, and a refresh lands on the
 * right phase from local storage. Everything runs in this browser.
 */
import { useEffect } from 'react'
import { useAppState } from '../store/appState.js'
import { Disclose } from '../screens/Disclose/index.js'
import { Import } from '../screens/Import/index.js'
import { Ledger } from '../screens/Ledger/index.js'
import { Reconstruct } from '../screens/Reconstruct/index.js'
import styles from './App.module.scss'

export function App() {
  const phase = useAppState((s) => s.phase)
  const hydrated = useAppState((s) => s.hydrated)
  const hydrate = useAppState((s) => s.hydrate)
  const setStudy = useAppState((s) => s.setStudy)

  useEffect(() => {
    hydrate()
    // Study mode (M3.10): a flag read once at boot, never a route.
    setStudy(import.meta.env.VITE_CORDELIA_STUDY === '1' || window.location.hash === '#study')
    // Dev-only fixture entry (M3.1): absent from the production bundle. Not a route.
    const fixture = import.meta.env.DEV ? import.meta.env.VITE_CORDELIA_FIXTURE : undefined
    if (import.meta.env.DEV && fixture) {
      void import('../dev/fixture.js').then(({ mountFixture }) => mountFixture(fixture))
    }
  }, [hydrate, setStudy])

  if (!hydrated) return null

  return (
    <div className={styles.root}>
      <header className={styles.masthead}>
        <p className={styles.brand}>Cordelia Mail</p>
        <p className={styles.tagline}>
          A ledger of what you owe and what you are owed, from your own mail.
        </p>
      </header>
      <main className={styles.main}>
        {phase === 'import' && <Import />}
        {phase === 'disclose' && <Disclose />}
        {phase === 'reconstruct' && <Reconstruct />}
        {phase === 'ledger' && <Ledger />}
      </main>
    </div>
  )
}
